export default __webpack_public_path__ + "static/media/Mårelius.70786f04.png";